import React, {
    useEffect, useState, useContext, useCallback
} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { TranslatorContext } from '@jutro/locale';
import { Tooltip } from '@jutro/components';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import {ModalNextProvider } from '@jutro/components';
import metadata from './PolicyCommonDetails.metadata.json5';
import styles from './PolicyCommonDetails.module.scss';
import messages from './PolicyCommonDetails.messages';
import { ClaimService } from '../../../../capabilities/nexus-capability-claim';
import { useDependencies } from 'gw-portals-dependency-react';
import { useAuthentication } from 'gw-digital-auth-react';

function MetadataTooltip({ children, ...rest }) {
    const translator = useContext(TranslatorContext);
    const child = Array.isArray(children) ? children[0] : children;
    return (
        <Tooltip {...rest} content={translator(messages.EmailMeTooltipMsg)}>
            {child}
        </Tooltip>
    );

    /* <Tooltip
        animation="fade"
        content={translator(messages.EmailMeTooltipMsg)}
        id="tooltip"
        placement="right-start"
        showOnInit={false}
        sticky
        trigger="mouseenter"
    >
        {child}
    </Tooltip>*/
}

function PolicyCommonDetails(props) {
    const { value: policyCommonDetails } = props;
    const translator = useContext(TranslatorContext);
    const [disableSendCSIOEmailButton, setDisableSendCSIOEmailButton] = useState(false);
    const [isPPVBodilyInjuryCoverageExist, setIsPPVBodilyInjuryCoverageExist] = useState(false);
    const [showSuccessEmailMsg, setShowSuccessEmailMsg] = useState(false);
    const [showBillingInfoMsg, setShowBillingInfoMsg] = useState(false);
    const { PolicyService } = useDependencies('PolicyService');
    const { authHeader } = useAuthentication();

    useEffect(() => {
        if (policyCommonDetails.policyStatusDisplay === 'In Force' && policyCommonDetails.lobs.businessAuto.lineOfBusiness) {
            /*_.each(policyCommonDetails.lobs.businessAuto.vehicleDTOs, (vehicle) => {
                if (vehicle.vehicleType === 'Private Passenger Vehicle') {
                    _.each(vehicle.coverages, (coverage) => {
                        if (coverage.name === 'Bodily Injury - Liability') {
                            setIsPPVBodilyInjuryCoverageExist(true);
                        }
                    });
                }
            });*/
            //visible for all Auto policies irrespective of any condition
            setIsPPVBodilyInjuryCoverageExist(true);
        }
        if (policyCommonDetails.policyStatusDisplay === 'Scheduled') {
            setShowBillingInfoMsg(true);
        }
    }, [policyCommonDetails]);

    const getPolHolderName = (polCommonDetails) => {
        const contacts1 = polCommonDetails.contacts;
        let insuredContact = {};
        if (contacts1 != null) {
            _.each(contacts1, (contact) => {
                if (contact.contactRole === 'Primary Named Insured') {
                    insuredContact = contact.contact;
                }
            });
        }
        return (
            <div>
                {insuredContact.displayName}
            </div>
        );
    };

    const sendPinkSlipEmail = useCallback(
        () => {
            setDisableSendCSIOEmailButton(true);
            PolicyService.sendCsioSlipByEmailToCustomer([policyCommonDetails.policyNumber], authHeader)
                .then((response) => {
                    console.log(response);
                    if (response.includes('Success')) {
                        setShowSuccessEmailMsg(true);
                        // Run after 10 minutes
                        setTimeout(() => {
                            setDisableSendCSIOEmailButton(false);
                            setShowSuccessEmailMsg(false);
                        }, 600000);
                    } else {
                        ModalNextProvider.showAlert({
                            title: messages.errorMsg,
                            message: messages.emailSentFailed,
                            status: 'error',
                            icon: 'mi-error-outline',
                            confirmButtonText: messages.ok
                        }).catch(_.noop);
                    }
                })
                .catch(() => {
                    ModalNextProvider.showAlert({
                        title: messages.errorMsg,
                        message: messages.emailSentFailed,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: messages.ok
                    }).catch(_.noop);
                    setDisableSendCSIOEmailButton(false);
                    return false;
                });
        },
        []
    );

    const getPolStatusName = (polCommonDetails) => {
        const status = polCommonDetails.policyStatusDisplay;
        let displayStatus = '';
        switch (status) {
            case ('In Force'):
            case ('Reinstated'):
            case ('Rewrite'):
                displayStatus = translator(messages.active);
                break;
            case ('Scheduled'):
                displayStatus = translator(messages.scheduled);
                break;
            default:
                displayStatus = translator(messages.inActive);
        }
        return displayStatus;
    };

    const overrides = {
        commonDetailsSection: {
            content: translator(messages.commonDetailsSection, {
                polNumber: policyCommonDetails.policyNumber
            })
        },
        policyHolderValue: {
            value: getPolHolderName(policyCommonDetails)
        },
        policyStatusValue: {
            value: getPolStatusName(policyCommonDetails)
        },
        pinkSlipGenerateContainer: {
            visible: isPPVBodilyInjuryCoverageExist
        },
        emailInstructionNote: {
            visible: showSuccessEmailMsg
        },
        pinkSlipEmailButton: {
            disabled: disableSendCSIOEmailButton,
            onClick: sendPinkSlipEmail
        },
        displayBillingInfoMessage:{
            visible: showBillingInfoMsg
        }
        /*emailSuccessMsgContainer: {
            visible: showSuccessEmailMsg
        }*/

    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={policyCommonDetails}
            overrideProps={overrides}
            classNameMap={styles}
            componentMap={{ tooltipcomponent: MetadataTooltip }}
        />
    );
}

PolicyCommonDetails.propTypes = {
    value: PropTypes.shape({})
};

PolicyCommonDetails.defaultProps = {
    value: {}
};

export default PolicyCommonDetails;
